@import "../../../../shared/scss";

:host {
  display: block;

  .form-container {
    display: block;
    position: relative;
    justify-content: space-between;
    align-items: center;
    inline-size: 100%;
    box-sizing: border-box;

    phn-p-text-field-wrapper {
      inline-size: 100%;
    }

    &.inline-search-form {
      margin-inline-end: p-px-to-rem(16px);
    }
  }

  .prediction-container {
    inset-block-start: calc(100% + 3px);
    box-sizing: border-box;
    position: absolute;
    z-index: 10;
    inline-size: 100%;

    background-color: white;
    border: 1px solid $pds-theme-light-contrast-low;

    ul {
      margin-block: 0;
      margin-inline: 0;
      padding-inline: 0;
      list-style-type: none;

      li {
        padding-inline-start: p-px-to-rem(12px);
        padding-block: p-px-to-rem(8px) p-px-to-rem(12px);
        padding-inline: p-px-to-rem(8px);
        color: $pds-theme-light-primary;

        &:hover {
          color: $pds-theme-light-notification-info;
          background-color: $pds-theme-light-background-surface;
        }

        &.highlighted-prediction {
          color: $pds-theme-light-notification-info;
        }
      }
    }

    .powered-by-google {
      margin-block: p-px-to-rem(12px);
      margin-inline: p-px-to-rem(12px) 0;
    }
  }
}
